'use client';

import { varAlpha } from 'minimal-shared/utils';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import MuiTextField from '@mui/material/TextField';
import { inputBaseClasses } from '@mui/material/InputBase';
import { inputLabelClasses } from '@mui/material/InputLabel';

import { CONFIG } from 'src/global-config';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export function ContactBaner({ sx, ...other }) {
  const renderEmail = () => (
    <Box
      sx={{
        mb: 2,
        gap: 1.5,
        display: 'flex',
        alignItems: 'center',
        color: 'common.black',
        justifyContent: { xs: 'center', md: 'center' },
        fontSize: '1.5rem',
      }}
    >
      {/* Do you want to join us? Download SHAHEN APP from the application store on your smartphone */}
    </Box>
  );

  const renderAddress = () => (
    <Box
      sx={{
        gap: 1.5,
        display: 'flex',
        alignItems: 'center',
        color: 'common.black',
        justifyContent: { xs: 'center', md: 'center' },
        fontSize: '1.5rem',
      }}
    >
      {/* We will be very happy if you visit us for a consultation in our office */}
    </Box>
  );

  return (
    <Box
      component="section"
      sx={[
        (theme) => ({
          ...theme.mixins.bgGradient({
            images: [`url(${CONFIG.assetsDir}/assets/images/home/contactUs.png)`],
          }),
          py: { xs: 10, md: 15 },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        <Grid container spacing={{ xs: 5, md: 3 }} sx={{ justifyContent: 'center' }}>
          <Grid xs={12} md={12} sx={{ textAlign: 'center' }}>
            <Typography
              variant="h1"
              component="h2"
              sx={(theme) => ({
                // ...theme.mixins.textGradient(
                //   `90deg, ${theme.vars.palette.primary.main} 20%, ${theme.vars.palette.secondary.main} 100%`
                // ),
                mb: { xs: 3, md: 5 },
                maxWidth: 1200,
                mx: 'auto',
                whiteSpace: 'normal',
                fontSize: '2.5rem !important',
                color: '#484848', // ✅ now it applies
                fontWeight: 700,
                lineHeight: 1.2,
                textAlign: 'center',
              })}
            >
              Lets work together hand in hand through a <br />
              distinguished partnership
            </Typography>

            {renderEmail()}
            {renderAddress()}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

// ----------------------------------------------------------------------

const TextField = styled((props) => <MuiTextField fullWidth {...props} />)(({ theme }) => ({
  [`& .${inputBaseClasses.root}`]: {
    backgroundColor: varAlpha(theme.vars.palette.grey['500Channel'], 0.16),
  },
  [`& .${inputBaseClasses.input}`]: { color: theme.vars.palette.common.white },
  [`& .${inputLabelClasses.root}.${inputLabelClasses.shrink}`]: {
    color: theme.vars.palette.grey[500],
    [`&.${inputLabelClasses.focused}`]: { color: theme.vars.palette.grey[500] },
  },
}));
